export const COUNTRY = {
  AU: 'AU',
  GB: 'GB',
  US: 'US',
};
